import { createReducer, on } from '@ngrx/store';
import {
  ActiveComponentChanged,
  ResetStateFromRouter,
} from 'src/app/shared/actions/eliqua.actions';

import {
  ClearMerchantSearchOptions,
  CompanyNameChanged,
  CompanyNamesSuccess,
  MemberStatusChanged,
  MerchantPageChanged,
  QivosIDChanged,
  RegistrationDateFromChanged,
  RegistrationDateFromCleared,
  SearchPanelStatusChanged,
  SubscriptionPlanChanged,
  SubscriptionPlansSuccess,
  VATNumberChanged,
} from '../actions/search.actions';
import { MerchantSearchState } from '../models/merchant.model';

const initialState: MerchantSearchState = {
  panelExpanded: true,
  companyNameValues: [],
  companyName: '',
  subscriptionPlanValues: [],
  subscriptionPlan: '',
  registrationDateFrom: new Date(0),
  registrationDateFromText: '',
  qivosID: '',
  memberStatus: false,
  vatNumber: '',
  mainPage: true,
};

export const MerchantSearchReducer = createReducer(
  initialState,
  on(SearchPanelStatusChanged, (state) => ({
    ...state,
    panelExpanded: !state.panelExpanded,
  })),
  on(CompanyNamesSuccess, (state, { res }) => ({
    ...state,
    companyNameValues: res,
  })),
  on(SubscriptionPlansSuccess, (state, { res }) => ({
    ...state,
    subscriptionPlanValues: res,
  })),
  on(CompanyNameChanged, (state, { companyName }) => ({
    ...state,
    companyName,
  })),
  on(SubscriptionPlanChanged, (state, { subscriptionPlan }) => ({
    ...state,
    subscriptionPlan,
  })),
  on(QivosIDChanged, (state, { qivosID }) => ({
    ...state,
    qivosID,
  })),
  on(RegistrationDateFromChanged, (state, { registrationDateFrom, registrationDateFromText }) => ({
    ...state,
    registrationDateFrom,
    registrationDateFromText,
  })),
  on(RegistrationDateFromCleared, (state) => ({
    ...state,
    registrationDateFrom: new Date(0),
    registrationDateFromText: '',
  })),
  on(MemberStatusChanged, (state) => ({
    ...state,
    memberStatus: !state.memberStatus,
  })),
  on(VATNumberChanged, (state, { vatNumber }) => ({
    ...state,
    vatNumber,
  })),
  on(MerchantPageChanged, (state) => ({
    ...state,
    mainPage: !state.mainPage,
  })),
  on(ClearMerchantSearchOptions, (state) => ({
    ...state,
    companyName: '',
    subscriptionPlan: '',
    registrationDateFrom: new Date(0),
    registrationDateFromText: '',
    qivosID: '',
    vatNumber: '',
    memberStatus: false,
  })),
  on(ActiveComponentChanged, (state, { activeComponent }) => ({
    ...state,
    companyNameValues:
      activeComponent !== 'MerchantSummaryComponent' &&
      activeComponent !== 'MerchantDetailsComponent' &&
      activeComponent !== 'MerchantCreateNewComponent' &&
      activeComponent !== 'MerchantSearchComponent'
        ? []
        : state.companyNameValues,
    companyName: '',
    subscriptionPlan: '',
    registrationDateFrom: new Date(0),
    registrationDateFromText: '',
    qivosID: '',
    memberStatus: false,
    mainPage:
      activeComponent !== 'MerchantSummaryComponent' &&
      activeComponent !== 'MerchantDetailsComponent'
        ? true
        : state.mainPage,
  })),
  on(ResetStateFromRouter, () => ({
    ...initialState,
  })),
);
